import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { withRouter } from '../withRouter';
import GameList from "constants/GameList";
import { addToCart } from 'actions/cart';

import AddonModal from '../AddonModal/AddonModal';
import styles from './GameAddonStyles.module.scss'
import PricingFunctions from '../../common/PricingFunctions';
import DotLoader from 'components/Utlility/DotLoader';
class GameAddon extends Component {
    static displayName = GameAddon.name;

    constructor(props) {
        super(props);

        this.state = {
            game: null,
            baseGame: GameList.find((x) => this.props.addon.forGameId === x.gameId),
            price: this.getPrice(),
            oldPrice: this.getPrice(true)
        };
    }

    componentDidMount() {

    }


    clickAddToCart(game) {
        if (this.shouldShowAddonModal()) this.setState({ showAddonModal: true });
        else this.props.addToCart(game);
    }

    ownsGame() {
        return this.props.owned;
    }

    getCardStyling() {
        // Bad name of method, this is specific to card background
        return {
            backgroundImage: `url(${this.props.addon.meta.cardBackground})`
        }
    }

    getCardPriceBannerStyling() {
        return {
            background: this.props.addon.meta.cardPriceColour
        }
    }

    getButtonStyling() {
        return {
            background: this.props.addon.meta.storeAccentColour
        }
    }

    clickGameCard = (e) => {
        e.preventDefault();

        if (this.props.fromLobby) {
            this.props.loadGameMenu(this.props.addon);
        } else {
            this.props.navigate(this.props.addon.storeSlug)
        }
    }

    getPrice(old) {
        return PricingFunctions.getGamePricing(this.props.pricing.countryCode, this.props.addon, old)?.display;
    }

    shouldShowAddonModal() {
        const ownsBaseGame = !!this.props.auth.user?.games.find(g => g.code === this.state.baseGame.gameId);
        const baseGameIsInCart = !!this.props.cart.items.find(i => i.productId === this.state.baseGame.productId);
        return !(ownsBaseGame || baseGameIsInCart)
    }

    addonModalCallback = () => {
        this.setState({ showAddonModal: false });
    }

    render() {
        return (
            this.props.addon && <>
                {this.state.showAddonModal && <AddonModal ref={this.ref} addon={this.props.addon} baseGame={this.state.baseGame} callback={this.addonModalCallback} ></AddonModal>}
                <div className={`${styles.gameCardWrapper} ${this.props.fromLobby && styles.lobby} ${!this.props.addon.enabled && styles.hidden}`}>
                    <div className={styles.gameCard}>
                        {
                            this.props.addonVotes > 0 &&
                            <div className={styles.votesCounter} style={this.getCardPriceBannerStyling()}><span>{this.props.addonVotes}</span></div>
                        }
                        <div onClick={this.clickGameCard} className={styles.clickOverlay} />
                        <div className={`${styles.gameCardBackground} ${this.props.fromLobby && styles.rounded}`} style={this.getCardStyling()}>
                            <img src={this.props.addon.meta.cardLogo} className={`${styles.gameCardLogo} ${this.props.addon.meta.cardLogo2 && styles.hasSecond}`} alt={`${this.props.addon.name} logo`}></img>
                            <div className={styles.addonBanner}>
                                Add-on
                            </div>
                            {this.props.addon.meta.cardLogo2 && <img src={this.props.addon.meta.cardLogo2} className={styles.gameCardLogo2} alt={`${this.props.addon.name} logo`}></img>}
                            {
                               // !this.props.fromLobby &&
                               // <div className={styles.priceBanner} style={this.getCardPriceBannerStyling()}><span>{this.getPrice() || <DotLoader size="small" variant="dark" />}</span></div>
                            }
                            {
                                this.props.addon.gameInfo.banner &&
                                <div className={styles.banner} style={this.getButtonStyling()}>{this.props.addon.gameInfo.banner}</div>
                            }
                        </div>
                        {
                            !this.props.fromLobby &&
                            <React.Fragment>

                                <div className={`${styles.cardDescriptionBox} p-3`}>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h4>{this.props.addon.name}</h4>
                                        <div className="d-flex align-items-center gap-2">                                            
                                                <h4 className="m-0" style={{ color: '#000000' }}>{this.state.price}</h4>
                                        </div>
                                    </div>
                                    <p>{this.props.addon.description}</p>
                                </div>
                                <button onClick={() => this.clickAddToCart(this.props.addon)} className={`${styles.addToCartBox} p-3`} disabled={this.props.addon.price === 0}>
                                    <h4>{this.props.addon.price === 0 ? "Auto Redeemed" : "Add To Cart"}</h4>
                                </button>
                            </React.Fragment>
                        }
                    </div>
                </div>
            </>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
        pricing: state.pricing,
        cart: state.cart,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (game) => {
            dispatch(addToCart(game))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GameAddon));
